import { Request } from "./https";

export const Payment = {
  get: (params) => {
    const newRequest = new Request("get", `payment-method`, params);
    return newRequest.sendXHR();
  },
};
